const isMobile = () => window.innerWidth <= 749;
  
function handleScroll() {
    const scrolled = window.scrollY > 10;
    if (!scrolled) return;

    const elements = {
        heroSec: document.getElementById("heroSec"),
        heroSecText: document.getElementById("heroSecText"),
        rlLogo: document.getElementById("rl-logo"),
        rotate: document.getElementById("rotate"),
        hand: document.getElementById("hand")
    };

    // Remove transform class from logo
    elements.rlLogo?.classList.remove("transform");

    // Apply different margins based on screen size
    if (window.innerWidth <= 1440) {
        if (isMobile()) {
        elements.heroSec.style.marginTop = "24px";
        elements.heroSecText.style.marginTop = "0px";
        } else {
        elements.heroSec.style.marginTop = "40px";
        elements.heroSecText.style.marginTop = "28px";
        }
    } else {
        elements.heroSec.style.marginTop = "40px";
    }

    // Add animation classes
    elements.rotate?.classList.add("loading");
    elements.hand?.classList.add("move");
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
    if(window.initIndexPage) window.addEventListener('scroll', handleScroll);
});